import { Navigate } from "react-router-dom";
import Error from "../page/error";
import UnAuthorize from "../page/unAuthorize";
import LogIn from "../page/user/login";
import Registration from "../page/user/Registration";
import AppLayout from "../component/layout/AppLayout";
import { appRoot } from "./constant/CONSTANTS";
import Blog from "../page/app/blog";
export const ROUTES = {
  FORGOT_PASSWORD: "/forgot-password",
  DASHBOARD: "/dashboard",
  TYPE: "/tiles/type",
  CATEGORY: "/tiles/category",
  CATALOGUE: "/catalogue",
  CONTACT: "/contact",
  PRODUCT: "/tiles/product",
  SINGLECATEGORY: "/tiles/category/:id",
  SINGLETYPE: "/tiles/type/:id",
  BLOG:"/blog",
  DOWNLOAD_PDF:"/download-pdf",
};

const LOGIN_ROUTES = [
  // {
  //   path: "/",
  //   element: <SidePage />,
  //   errorElement: <Error />,
  //   children: [
  //     {
  //       index: true,
  //       element: <LogIn />,
  //     },
  //     {
  //       path: "registration",
  //       element: <Registration />,
  //     },
  //   ],
  // },
  {
    index: true,
    element: <LogIn />,
  },
  {
    path: "registration",
    element: <Registration />,
  },
  // {
  //   path: ROUTES.FORGOT_PASSWORD,
  //   element: <ForgetPassword />,
  //   errorElement: <Error />,
  // },
];

const ALL_ROUTES = [
  ...LOGIN_ROUTES,

  {
    path: `${appRoot}`,
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: <Navigate to={`${appRoot}${ROUTES.BLOG}`} />,
      },
      {
        path: `${appRoot}${ROUTES.BLOG}`,
        element: <Blog />,
      },
    ],
  },
  {
    path: "/error",
    element: <Error />,
  },
  {
    path: "/unAuthorize",
    element: <UnAuthorize />,
  },
  // {
  //   path: "*",
  //   element: <Navigate to="/error" />,
  // },
];

export default ALL_ROUTES;
